module.exports = __webpack_public_path__ + "images/video-reel-with-play-button.jpg?904be";